import { z } from "zod";
import { defineStepConfig } from "@erp/workflows";

/**
 * Match Supplier with Famous Step
 *
 * Use Famous vendor data to assist in supplier matching.
 * This improves matching accuracy by cross-referencing with
 * the Famous Software ERP system's vendor master data.
 *
 * Note: This is a backend-only step that requires Famous API access.
 * The handler is registered in backend/src/workflows/steps/handlers/
 */
export const matchSupplierWithFamousStep = defineStepConfig({
  type: "match_supplier_with_famous",
  name: "Match Supplier (Famous)",
  description: "Match supplier using Famous Software vendor data",
  category: "Integration",

  inputSchema: z.object({
    supplierName: z.string().optional(),
    supplierAddress: z.string().optional(),
    organizationId: z.uuid(),
  }),

  outputSchema: z.object({
    famousVendorId: z.string().optional(),
    matchConfidence: z.number().optional(),
    matched: z.boolean(),
  }),

  configSchema: z.object({}),

  emits: [] as const,
});
